import { render, staticRenderFns } from "./TripleTableGroupingComponent.vue?vue&type=template&id=6f077581&scoped=true"
import script from "./TripleTableGroupingComponent.vue?vue&type=script&lang=js"
export * from "./TripleTableGroupingComponent.vue?vue&type=script&lang=js"
import style0 from "./TripleTableGroupingComponent.vue?vue&type=style&index=0&id=6f077581&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f077581",
  null
  
)

export default component.exports